import { SVGProps } from 'react';

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="18"
    fill="none"
    viewBox="0 0 12 18"
  >
    <path
      fill="#0D4B9B"
      d="M6 .566c-3.307 0-6 2.693-6 6 0 4.178 5.22 10.005 5.445 10.253l.555.615.555-.615C6.78 16.57 12 10.744 12 6.566c0-3.307-2.693-6-6-6M6 15.17C4.365 13.21 1.5 9.22 1.5 6.566c0-2.482 2.018-4.5 4.5-4.5s4.5 2.018 4.5 4.5c0 2.873-3.187 7.02-4.5 8.603M4.853 8.194l-1.32-1.328-1.065 1.065 2.385 2.385L9.36 5.81 8.303 4.744z"
    ></path>
  </svg>
);

export default SvgIcon;
